import { bridgeDiscoveryPresentation } from '../bridge/discovery.js';
import { ginRummyDiscoveryPresentation } from '../gin-rummy/discovery.js';
import { heartsDiscoveryPresentation } from '../hearts/discovery.js';
import { spadesDiscoveryPresentation } from '../spades/discovery.js';
import type { GameDiscoveryPresentation } from './types.js';

export { SuitGlyph, type SuitKind } from './cards.js';
export type { GameDiscoveryPresentation } from './types.js';

const entries = [
  bridgeDiscoveryPresentation,
  heartsDiscoveryPresentation,
  spadesDiscoveryPresentation,
  ginRummyDiscoveryPresentation,
] satisfies readonly GameDiscoveryPresentation[];

const presentations = new Map<string, GameDiscoveryPresentation>(entries.map((entry) => [entry.gameId, entry]));

export function getGameDiscoveryPresentation(gameId: string): GameDiscoveryPresentation | undefined {
  return presentations.get(gameId);
}
